export default {
    type: 'add',
    id: 0,
    tab: 'main',
    visible: true,
    loading: false,
}